import kakaoDesktop from "public/images/landing/seniors/kakao_desktop.png";
import hackleDesktop from "public/images/landing/seniors/hackle_desktop.png";
import kraftonDesktop from "public/images/landing/seniors/krafton_desktop.png";
import kakaoMo from "public/images/landing/seniors/kakao_mo.png";
import hackleMo from "public/images/landing/seniors/hackle_mo.png";
import kraftonMo from "public/images/landing/seniors/krafton_mo.png";

import kakao from "public/images/landing/seniors/kakao_logo.png";
import woowa from "public/images/landing/seniors/woowa_logo.png";
import mathpresso from "public/images/landing/seniors/mathpresso_logo.png";
import class101 from "public/images/landing/seniors/class101_logo.png";
import frip from "public/images/landing/seniors/frip_logo.png";
import lg from "public/images/landing/seniors/lg_logo.png";
import sandbox from "public/images/landing/seniors/sandbox_logo.png";

export const landingSeniorsDataDesktop = [
  {
    interview:
      "입사 하기까지의 과정이 아닌,\n" +
      "입사 이후에 PM이 일하는 방법이\n" +
      "담겨있는 과정이에요.",
    img: kakaoDesktop,
  },
  {
    interview:
      "비즈니스를 성공시키기 위한\n" +
      "데이터 기반 사고 방식을\n" +
      "경험해볼 수 있다는 게 좋았어요.",
    img: hackleDesktop,
  },
  {
    interview:
      "기획부터 런칭, 배포, 개선까지 모든\n" +
      "과정을 거치는 게 아주 매력적이에요.\n" +
      "현업에서 큰 도움이 될 거예요.",
    img: kraftonDesktop,
  },
];

export const landingSeniorsDataMobile = [
  {
    interview:
      "입사 하기까지의 과정이 아닌,\n" +
      "입사 이후에 PM이 일하는 방법이\n" +
      "담겨있는 과정이에요.",
    img: kakaoMo,
  },
  {
    interview:
      "비즈니스를 성공시키기 위한\n" +
      "데이터 기반 사고 방식을\n" +
      "경험해볼 수 있다는 게 좋았어요.",
    img: hackleMo,
  },
  {
    interview:
      "기획부터 런칭, 배포, 개선까지 모든\n" +
      "과정을 거치는 게 아주 매력적이에요.\n" +
      "현업에서 큰 도움이 될 거예요.",
    img: kraftonMo,
  },
];

export const mktLandingPageSeniorsMentData = [
  {
    id: 1,
    ment: "이 시대 마케터가 지녀야 할 필수 역량을 다 갖춘 커리큘럼인 것 같습니다. 효율적으로 알려주는 사수가 없는 분들은 무조건이에요.",
    name: "노**",
    role: "마케팅팀 총괄",
    logo: kakao,
  },
  {
    id: 2,
    ment: "실제 데이터를 바탕으로 실무 경험을 할 수 있는 부트캠프! 저도 취업 전에 알았다면 실력을 키울 수 있어 더 좋았던 것 같아요",
    name: "윤서정",
    role: "3년차 마케터",
    logo: woowa,
  },
  {
    id: 3,
    ment: "SW캠프는 현재 시장에서 꼭 필요로 하는 마케터를 양성하는 코스입니다. 즉, 크고 작은 마케팅 액션을 통해 마케팅 전략을 최대한 선명하게 제시하는 역량을 기를 수 있는 커리큘럼입니다.",
    name: "박무진",
    role: "5년차 브랜드 마케터",
    logo: mathpresso,
  },
  {
    id: 4,
    ment: "마케터에게는 문제 해결 역량이 가장 중요한 역량이라 생각합니다. SW캠프는 마케터의 필수 조건인 문제 해결 능력을 빠르게 높일 수 있는 탁월한 커리큘럼입니다.",
    name: "김**",
    role: "5년차 퍼포먼스 마케터",
    logo: class101,
  },
  {
    id: 5,
    ment: "마케터로서 필요한 기술의 기초를 모두 배울 수 있는 커리큘럼으로 구성되어 있습니다. 퍼포먼스 및 그로스 등 데이터적 사고가 필수인 마케터에게 필수적입니다.",
    name: "김**",
    role: "9년차 그로스 마케터",
    logo: frip,
  },
  {
    id: 6,
    ment: "시니어, 주니어 멘토진의 밀착 관리로 초보 마케터로서의 미래 방향성 확립에 큰 도움이 되는 커리큘럼인 것 같아요.",
    name: "류**",
    role: "3년차 글로벌 매니저",
    logo: lg,
  },
  {
    id: 7,
    ment: "실무적으로 다루는 영역을 커리어적으로 더 확장하여 다뤄볼 수 있는 커리큘럼인 것 같아요!",
    name: "이한솔",
    role: "3년차 마케터",
    logo: sandbox,
  },
];
